import * as crossBorderActions from '../actions/crossBorder';

const defaultState = {
  crossBorderQuote: null,
  gettingCrossBorderQuote: false,
  spotRate: null,
  gettingSpotRate: false,
};

// eslint-disable-next-line default-param-last
const crossBorder = (state = defaultState, action) => {
  switch (action.type) {
    case crossBorderActions.GET_CROSS_BORDER_QUOTE: {
      const { getCrossBorderQuoteError, ...newState } = state;
      return {
        ...newState,
        gettingCrossBorderQuote: true,
      };
    }
    case crossBorderActions.GET_CROSS_BORDER_QUOTE_SUCCESS:
      return {
        ...state,
        crossBorderQuote: action.payload,
        gettingCrossBorderQuote: false,
      };
    case crossBorderActions.GET_CROSS_BORDER_QUOTE_ERROR:
      return {
        ...state,
        getCrossBorderQuoteError: action.payload,
        gettingCrossBorderQuote: false,
      };
    case crossBorderActions.CLEAR_CROSS_BORDER_QUOTE: {
      const { crossBorderQuote, ...newState } = state;
      return newState;
    }
    case crossBorderActions.GET_SPOT_RATE: {
      const { getSpotRateError, ...newState } = state;
      return {
        ...newState,
        gettingSpotRate: true,
      };
    }
    case crossBorderActions.GET_SPOT_RATE_SUCCESS:
      return {
        ...state,
        spotRate: action.payload,
        gettingSpotRate: false,
      };
    case crossBorderActions.GET_SPOT_RATE_ERROR:
      return {
        ...state,
        getSpotRateError: action.payload,
        gettingSpotRate: false,
      };
    case crossBorderActions.CLEAR_SPOT_RATE: {
      const { spotRate, ...newState } = state;
      return newState;
    }
    case crossBorderActions.TRACK_CROSS_BORDER_QUOTE: {
      const { crossBorderRequestId, ...newState } = state;
      return {
        ...newState,
        ...action.payload,
      };
    }
    case crossBorderActions.EXECUTE_CROSS_BORDER_QUOTE_SUCCESS:
      return {
        ...state,
        crossBorderQuote: {
          ...state.crossBorderQuote,
          steps: action.payload,
        },
      };
    case crossBorderActions.EXECUTE_CROSS_BORDER_QUOTE_ERROR:
      return {
        ...state,
        executeCrossBorderQuoteError: action.payload,
      };
    default:
      return state;
  }
};

export default crossBorder;
